import { render, staticRenderFns } from "./VideoProfile.vue?vue&type=template&id=5ac633c2&scoped=true&"
import script from "./VideoProfile.vue?vue&type=script&setup=true&lang=ts&"
export * from "./VideoProfile.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./VideoProfile.vue?vue&type=style&index=0&id=5ac633c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac633c2",
  null
  
)

export default component.exports